/**
 * @desc 根据退款单号获取明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RefundOrderOperationDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/getItemList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
